import { IGetCalendarAuthUrlParams } from 'APP/model/calendar/calendar.types';
import { calendarModel } from 'APP/model/model';

export const getCalendarAuthUrl = async (params: IGetCalendarAuthUrlParams): Promise<string> => {
  try {
    const url = await calendarModel.getCalendarAuthUrl(params);

    return url;
  } catch {
    return '';
  }
};
